module.exports = __webpack_public_path__ + "img/fifthedge.5cd7500c.png";